import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ProgressService } from './progress.service';
import { HomeService } from '../home/home.service';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../utility';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { SidebarService } from '../shared/services/sidebar.service';
import { HelperService } from '../shared/services/helper.service';
import { PageMetadataService } from '../shared/services/page-metadata.service';
import { HttpService } from '../shared/services/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-progress-dashboard',
  templateUrl: './progress-dashboard.component.html',
  styleUrl: './progress-dashboard.component.css',
})
export class ProgressDashboardComponent {
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  outcomeYear: { key: number; value: number }[];

  // toggle button
  outcomeType: any[] = [
    { label: 'STO', value: 'quarterly' },
    { label: 'MTO', value: 'annual' },
  ];

  value: string = 'quarterly';

  viewOptions: any[] = [
    { icon: 'hugePieChart', val: 'chartView' },
    { icon: 'hugeLeftToRightListBullet', val: 'listView' },
  ];
  val: string = 'chartView';

  themes: any[];
  barColor: any[];
  themesColor: any[];
  graphtypes: any[];
  graphstatus: number[] = [0, 0, 0, 0, 0]; // Initialize the array for graph data
  outcomesList: any[];
  QTypeOfWork: boolean = true;
  QTypeOfWorkA: boolean = true;
  QStatusWise: boolean = true;
  QStatusWiseA: boolean = true;
  QThemeWise: boolean = true;
  isLoading: boolean = true;
  private roleSubscription: Subscription;
  private progressService = inject(ProgressService);
  private homeService = inject(HomeService);
  public helper = inject(HelperService);
  private httpService = inject(HttpService);
  private route = inject(ActivatedRoute);
  public sidebarService = inject(SidebarService);
  private router = inject(Router);
  private apiService = inject(ApiService);
  private pageMetaData = inject(PageMetadataService);

  outcomeListUrl: string = '';
  isSidebarOpen: boolean = false;
  filterCount: number;
  outcomListData: any;
  filteredType: string;
  types: string;
  quarter: any;
  currentYear: any;
  filterDataObj: any = this.sidebarService.dashboardData;
  quaterSubscription: Subscription;
  overAllGroupsSubs: Subscription;
  selectedRole: string;
  activeView: any;
  activePeriod: any;
  outcome_year: any;
  NoCountShow: boolean = false;
  isTypedLoading: boolean = false;
  NoCountShowType: boolean = false;
  isThemeLoading: boolean = false;
  hasOutcomesThemes: any;
  progressDashboardListParentGroup: any[];
  selectProgressDashSubGroupsData: any=[];
  progressDashTeamMembers: any=[];
  // constructor(
  //   public ref: DynamicDialogRef,
  //   public config: DynamicDialogConfig
  // ) {}

  ngOnInit(): void {
    this.outcomeYear = this.helper.generateYearArray(2022);
    if (this.sidebarService.selectedChartProgressDashboardYear == null) {
      this.sidebarService.selectedChartProgressDashboardYear = {
        key: new Date().getFullYear(),
        value: new Date().getFullYear(),
      };
      this.outcome_year = new Date().getFullYear();
    }

    if (this.sidebarService.selectedChartProgressDashboardYear) {
      this.sidebarService.selectedChartProgressDashboardYear
      this.outcome_year =this.sidebarService.selectedChartProgressDashboardYear.value
    }
    this.searchQuery = '';
    this.pageMetaData.setTitle('Progress Dashboard | OBP');
    this.fetchCurrentQuater();
    this.breadCrumbItems = [{ label: 'Progress Dashboard' }];
    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.selectedRole = data;
      // this.getgraphTypes(data,'quarterly');
      // this.getgraphStatus(data,'quarterly');
      this.value = data === 'affiliate' ? 'annual' : 'quarterly';
      // this.val = data === 'affiliate' ? 'chartView' : 'listView';
      // this.val = 'chartView';
      // this.route.queryParams.subscribe((params) => {
      //   const view = params['view'];
      //   const period = params['period'];

      //   this.activeView = view;
      //   this.activePeriod = period;
      // });

      if (data === 'affiliate') {
        this.outcomeType = [{ label: 'Annual', value: 'annual' }];
        // this.viewOptions = [
        //   { icon: 'hugeLeftToRightListBullet', val: 'listView' }
        // ];
        this.value = 'annual';
        // this.val = 'listView';
      } else {
        this.outcomeType = [
          { label: 'STO', value: 'quarterly' },
          { label: 'MTO', value: 'annual' },
        ];
        // this.viewOptions = [
        //   { icon: 'hugePieChart', val: 'chartView' },
        //   { icon: 'hugeLeftToRightListBullet', val: 'listView' },
        // ];
        this.value = 'quarterly';
        //  this.val = 'chartView';
      }
      this.filteredType = data;
      this.types = data === 'affiliate' ? 'annual' : 'quarterly';
      // this.getgraphThemes(data, data === 'affiliate' ? 'annual' : 'quarterly');
      // this.getgraphStatus(data, data === 'affiliate' ? 'annual' : 'quarterly');

      this.loadGraphData(data);
      this.quarterList(data);
      this.outcomeListUrl = `${environment.opbBackendHost}/api/${data}/dashboard/list`;
      // this.getOutcomesList(data, data === 'affiliate' ? 'annual' : 'quarterly');
    });
    this.quaterSubscription = this.apiService.quarter$.subscribe((data) => {
      this.sidebarService.dashboardData.outcome_quarters = data;
    });
    this.initialLoad()

    // this.helper.fetchParentStandaloneGroupList(this.selectedRole, 'progress');

    // this.overAllGroupsSubs = this.helper.parentStandaloneGroupList$.subscribe(
    //   (data: any) => {
    //     if (this.selectedRole != 'affiliate') {
    //       this.sidebarService.dashboardData.parent_group = data[0]?.group_id;
    //       this.helper
    //         .getSubgroupListData(this.selectedRole, data[0]?.group_id, true)
    //         .subscribe((res: any) => {
    //           this.sidebarService.dashboardData.outcome_groups = res?.data[0]?.group_id;
    //         });
    //     }
    //   }
    // );
    //this.val = this.activeView;
    //this.value=this.activePeriod
    if (this.val == 'chartView') {
      this.loadGraphData(this.selectedRole);
    } else {
      this.onProgressDashboard(this.filterDataObj);
    }
  }
  onProgressDashboardYearChange(event: any) {
    this.sidebarService.selectedChartProgressDashboardYear = event?.value;
    // this.sidebarService.dashboardData.outcome_year = event?.value?.value;
    // this.progressDashboardSelection.emit(this.sidebarService.dashboardData);
    // this.sidebarService.selectedProgressDashboardBusinessTheme=null
    // this.getQuarterListByYear(this.selectedRole,event?.value?.value)
    // this.fetchThemeListBasedOnYear(event?.value?.value)
    this.outcome_year = event?.value?.value;
    this.onChangeToggle();
  }

  initialLoad(){
      this.helper
        .fetchParentStandaloneGroupList(this.selectedRole, 'page') // send by parent Id
        .subscribe((responseParent: any) => {
          this.progressDashboardListParentGroup = responseParent?.data || responseParent;
          this.helper
            .fetchParentStandaloneGroupList(this.selectedRole, '') // without parent ID
            .subscribe((res: any) => {
              if(this.selectedRole !='affiliate'){
                this.sidebarService.selectedProgressDashboardGroup =
                  this.progressDashboardListParentGroup[0];
                }else{
                this.sidebarService.selectedProgressDashboardGroup =null
              }
            });

          this.helper
            .getSubgroupListData(
              this.selectedRole,
              this.progressDashboardListParentGroup[0]?.group_id,
              true
            )
            .subscribe((response: any) => {
              this.helper
                .getSubgroupListData(
                  this.selectedRole,
                  this.progressDashboardListParentGroup[0]?.group_id,
                  false
                )
                .subscribe((responseWithoutMemberID: any) => {
                  let merged = [
                    this.selectProgressDashSubGroupsData,
                    ...responseWithoutMemberID.data,
                  ];
                  const mergedGroups = Array.from(
                    new Map(
                      merged?.map((group) => [group?.group_id, group])
                    ).values()
                  ).filter((group) =>
                    Object.values(group).some(
                      (value) =>
                        value !== null && value !== '' && value !== undefined
                    )
                  );

                  this.selectProgressDashSubGroupsData = mergedGroups;
                });
                
              this.sidebarService.selectedProgressDashboardSubgroup = response?.data[0];
              this.helper
                .fetchMembersList(this.selectedRole, {
                  groups: this.sidebarService.selectedProgressDashboardSubgroup?.group_id || this.progressDashboardListParentGroup[0]?.group_id,
                })
                ?.subscribe((resp: any) => {

                  this.helper
                .fetchMembersList(this.selectedRole, {
                  include_members: this.helper.loggedInUser?.user_id,
                }).subscribe((loggedUser:any)=>{
                  this.progressDashTeamMembers=[...this.progressDashTeamMembers,...loggedUser.data,...resp?.data]
                  const uniqueMember = Array.from(
                    new Map(
                      this.progressDashTeamMembers.map((member: any) => [
                        member.user_id,
                        member,
                      ])
                    ).values()
                  );
                
                  this.progressDashTeamMembers = uniqueMember;
                  this.sidebarService.selectedProgressDashboardMembers = this.progressDashTeamMembers?.find(
                    (m: any) => m.user_id === this.helper.loggedInUser.user_id
                  );
                  this.sidebarService.dashboardData.group_members = this.sidebarService.selectedProgressDashboardMembers?.user_id;
                })

                  const loggedInUserId = this.helper.loggedInUser.user_id;
                  const selectedGroupId =
                    this.sidebarService.selectedProgressDashboardSubgroup?.group_id || this.progressDashTeamMembers[0]?.group_id;
                  const currentYear = new Date().getFullYear();
                  const parentGroupId = response?.data[0]?.group_id;
                  this.sidebarService.dashboardData = {
                    ...this.sidebarService.dashboardData,
                    parent_group: parentGroupId || loggedInUserId,
                    outcome_groups: selectedGroupId,
                    outcome_year: currentYear,
                  };

                  this.onDropdownSelection({
                    ...this.sidebarService.dashboardData,
                    group_members: loggedInUserId,
                  });
                });
            });
        });
  }


  onProgressTeamMemeber(data: any) {
    if (Array.isArray(data)) {
      const combined = [...this.progressDashTeamMembers, ...data];
      this.progressDashTeamMembers = Array.from(
        new Map(combined.map(member => [member.user_id, member])).values()
      );
    } else if (data && typeof data === "object" && "user_id" in data) {
      const index = this.progressDashTeamMembers.findIndex(
        (member: any) => member.user_id === data.user_id
      );
    
      if (index !== -1) {
        this.progressDashTeamMembers[index] = data;
      } else {
        this.progressDashTeamMembers.push(data);
      }
    }
    
  }

  searchQuery: string = '';
  onSearchInput() {
    let data = {
      search: this.searchQuery,
      ...this.sidebarService?.dashboardData,
    };
    this.isOutcomeListLoaded = true;
    this.getFilteredOutcomeList(this.filteredType, data);
  }

  loadGraphData(data: any) {
    if (data == 'affiliate') {
      this.getgraphStatus(data, this.value);
      this.getgraphThemes(data, this.value);
    } else {
      this.getgraphTypes(data, this.value);
      this.getgraphStatus(data, this.value);
      this.getgraphThemes(data, this.value);
    }
  }

  onProgressDashboard(filterData: any) {
    this.searchQuery = '';
    this.filterDataObj = this.sidebarService.dashboardData;
    const { outcome_quarters = '', ...remain } = this.filterDataObj;

    this.types == 'annual'
      ? (this.outcomListData = remain)
      : (this.outcomListData = this.filterDataObj);

    this.filterCount = this.getFilledPropertiesCount(this.outcomListData);
    this.getFilteredOutcomeList(this.filteredType, this.outcomListData);
  }

  fetchCurrentQuater() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/quarter`, {})
      .subscribe((res: any) => {
        this.onDropdownSelection({
          ...this.sidebarService?.dashboardData,
          outcome_quarters: res?.data?.quarter,
        });
      });
  }

  fetchCurrentYear(cat: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/year`, {})
      .subscribe((res: any) => {
        this.currentYear = res?.data;
      });
  }
  onDropdownSelection(filterData: any) {
    this.filterCount = this.getFilledPropertiesCount(filterData);
  }
  quarterList(cat: string) {
    const data = {
      year: this.currentYear,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  getFilledPropertiesCount(data: any) {
    let length = Object.keys(data).filter(
      (key) => data[key] !== null && data[key] !== '' && data[key] != undefined
    )?.length;

    // if (data.outcome_groups == data.parent_group ) {
      if( data.outcome_groups ==''){
        length -=1;
      }
      // length -=1;
    // }
    return length;
  }
  getFilteredOutcomeList(type: any, data: any) {
    this.outcomListData = {
      ...data,
      outcome_type: this.types,
      search:this.searchQuery
    };
    this.isOutcomeListLoaded = true;

    this.homeService.getOutcomesList(this.outcomListData, type).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.outcomesList = parsedData.data || [];
          this.isOutcomeListLoaded = false;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
          this.isOutcomeListLoaded = false;
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onDataLoaded(data: any[]) {
    this.outcomesList = data;
  }

  getgraphThemes(cat: string, outcome_type: string) {
    this.isThemeLoading = true;
    this.progressService
      .getProgressTheme({ outcome_year: this.outcome_year }, cat)
      .subscribe(
        (data: any) => {
          try {
            const parsedData = data;
            this.themes = [parsedData.data.outcomes_count];
            this.hasOutcomesThemes = parsedData?.data.some(
              (theme: any) => theme?.outcomes_count > 0
            );
            this.themeFields(parsedData.data);
            this.isThemeLoading = false;
          } catch (error) {
            this.isThemeLoading = false;

            console.error('Error parsing decoded data:', error);
          }
        },
        (error) => {
          console.error('Error fetching users', error);
        }
      );
  }
  getgraphTypes(cat: string, outcome_type: string) {
    const data = {
      outcome_quarters: '1,2,3,4',
      outcome_type: outcome_type,
      outcome_year: this.outcome_year,
    };
    this.isTypedLoading = true;
    this.progressService.getGraphType(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.graphtypes = [
            parsedData.data.adhoc, // adhoc
            parsedData.data.foundational, // foundational
            parsedData.data.workpackage, // workpackage
          ];
          this.isTypedLoading = false;
          this.NoCountShowType = Object.values(parsedData.data).every(
            (value) => value === 0
          );


          this.QTypeOfWork = false;
        } catch (error) {
          this.isTypedLoading = false;

          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  getgraphStatus(cat: string, outcome_type: string) {
    // this.QStatusWise = true;
    const data = {
      outcome_type: outcome_type,
      outcome_year: this.outcome_year,
    };
    this.QStatusWise = true;
    this.QStatusWiseA = true;
    this.progressService.getGraphStatus(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.graphstatus = [
            parsedData.data.notstarted, // Not Started
            parsedData.data.ongoing, // Ongoing
            parsedData.data.completed, // Completed
            parsedData.data.delayed, // Delayed
            parsedData.data.terminated, // Terminated
          ];
          this.NoCountShow = Object.values(parsedData.data).every(
            (value) => value === 0
          );

          if (outcome_type === 'annual') {
            this.QStatusWiseA = false;
          }

          if (outcome_type === 'quarterly') {
            this.QStatusWise = false;
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }
  isOutcomeListLoaded: boolean = false;
  getOutcomesList(cat: string, outcome_type: string) {
    const data = {
      outcome_type: outcome_type,
    };
    this.outcomListData = {
      ...data,
    };
    this.isOutcomeListLoaded = true;
    this.homeService.getOutcomesList(this.outcomListData, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.outcomesList = parsedData.data || [];
          this.isLoading = false;
          // const standalone = [...group.chapter.standalone, ...group.cluster.standalone, ...group.function.standalone];

          this.isOutcomeListLoaded = false;

          // this.groupFilter= standalone.map((item:any) => ({ label: item.name, value: item.group_id }));
        } catch (error) {
          console.error('Error parsing decoded data:', error);
          this.isOutcomeListLoaded = false;
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  themeFields(themes: any[]) {
    if (themes && Array.isArray(themes)) {
      const themeData: any = [];
      const themeDataVal: any = [];
      const barColorVal: any = [];
      themes.forEach((theme) => {
        themeData.push(theme.value);
        themeDataVal.push(theme.outcomes_count);
        barColorVal.push(theme.color);
      });

      this.themesColor = [...themeData];
      this.themes = [...themeDataVal];
      this.barColor = [...barColorVal];
      this.QThemeWise = false;
      this.QStatusWise = false;
    }
  }

  onChangeToggle() {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.outcomeListUrl = `${environment.opbBackendHost}/api/${data}/dashboard/list`;

      if (this.val == 'chartView') {
        this.loadGraphData(data);
      } else {
        // this.getOutcomesList(data, outcome_type);
        this.onProgressDashboard(this.filterDataObj);
      }
    });
  }

  onChangeViewType(typeVal: any): void {
    this.val = typeVal;
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { view: typeVal },
    //   queryParamsHandling: 'merge',
    // });
    if (typeVal == 'chartView') {
      this.isSidebarOpen = false;
    }
    this.onChangeToggle();
    // this.roleSubscription = this.apiService.role$.subscribe((data) => {
    //   if (typeVal == 'chartView') {
    //     this.loadGraphData(data);
    //   } else {
    //     this.getOutcomesList(data, this.value);
    //   }
    // });
  }

  onValueChange(outcome_type: any): void {
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { period: outcome_type },
    //   queryParamsHandling: 'merge',
    // });
    this.searchQuery = '';
    this.isOutcomeListLoaded = true;
    this.types = outcome_type;
    this.onChangeToggle();

    // this.roleSubscription = this.apiService.role$.subscribe((data) => {
    //   this.outcomeListUrl = `${environment.opbBackendHost}/api/${data}/dashboard/list`;

    //   if (this.val == 'chartView') {
    //     this.loadGraphData(data);
    //   } else {
    //     // this.getOutcomesList(data, outcome_type);
    //     this.onProgressDashboard(this.filterDataObj);
    //   }
    // });
    // Perform any additional operations here based on the selected value.
  }

  ngOnDestroy() {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
      this.quaterSubscription?.unsubscribe();
    }
    this.sidebarService.cleanHomeProgressDashboardSelection()

  }
}
